import { deepEquals } from 'app/infrastructure/js';
import { userMembersAction } from '../constants';
import { ListAction } from '../types-store';

export const appendAction = (allActions: ListAction[], currentAction: ListAction) => {

  if (!currentAction) {
    return allActions ?? [];
  }

  if (currentAction.type === userMembersAction.selectAll ||
    currentAction.type === userMembersAction.deselectAll ||
    (allActions?.length ?? 0) === 0) {

    return [currentAction];
  }

  let isDuplicate = false;

  for (const action of [...allActions].reverse()) {

    if (action.type === userMembersAction.selectAll ||
      action.type === userMembersAction.deselectAll) {

      isDuplicate = (action.type === userMembersAction.selectAll &&
        currentAction.type === userMembersAction.select) ||
        (action.type === userMembersAction.deselectAll &&
          currentAction.type === userMembersAction.deselect);
      break;
    }

    if (action.type === userMembersAction.select &&
      currentAction.type === userMembersAction.deselect &&
      deepEquals(currentAction.path, action.path.slice(0, currentAction.path.length))) {

      break;
    }

    if (deepEquals(action.path, currentAction.path.slice(0, action.path.length))) {

      if (action.propagate ||
        (!currentAction.propagate && deepEquals(action.path, currentAction.path))) {

        isDuplicate = action.type === currentAction.type;
        break;
      }
    }
  }

  if (isDuplicate) {
    return allActions;
  }

  const filteredActions = allActions.filter(action => {

    if (action.type === userMembersAction.selectAll ||
      action.type === userMembersAction.deselectAll ||
      !deepEquals(currentAction.path, action.path.slice(0, currentAction.path.length))) {
      return true;
    }

    const overwritesChildren = currentAction.propagate ||
      (!action.propagate && deepEquals(currentAction.path, action.path));

    const overwritesParents = action.type === currentAction.type ||
      action.type !== userMembersAction.select ||
      currentAction.path.length === 1;

    return !(overwritesChildren && overwritesParents);
  });

  return [
    ...filteredActions,
    currentAction
  ];
};
